import { render, staticRenderFns } from "./tasks-modal-list.vue?vue&type=template&id=09677622"
import script from "./tasks-modal-list.vue?vue&type=script&lang=js"
export * from "./tasks-modal-list.vue?vue&type=script&lang=js"
import style0 from "./tasks-modal-list.vue?vue&type=style&index=0&id=09677622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports